export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-04.jpg'),
        title: '人工知能',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'AIを取り入れることは未来を取り入れることです',
      description: `<p style="font-size:1.05rem">人工知能は世界中の企業のイノベーションを牽引しています。人工知能は、かつて人間だけが行っていた知的作業をコンピュータに学習させる分野であり、学習、推論、思考などの人間の知能プロセスを模倣します。機械学習や深層学習により、アイデアは実用化へと移行し、今日では音声処理や画像処理の分野で大きな進歩を遂げています。</p>`
    },
    {
      title: '私たちの強み',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-04.jpg')+`)"></span>
      <span>MaesInfoは、高度な機械学習・深層学習の技術者および博士クラスの人材を擁しています。一流大学出身の研究者と連携し、医療画像処理、機械翻訳、教育支援、画像認識など多岐にわたる分野で最先端技術を応用してきました。企業向けの専門的なAIソリューションを提供し、人件費の削減と業務運用の効率・精度向上を支援します。</span>`
    }
  ]
}
